import Client from './client';

export default class FlowLabelSettings extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(options = {}) {
    return this.makeRequest(`${this.host}/internal/label/settings`, {
      ...options,
       method: 'POST',
    });
  }

  getById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/label/settings/${id}`, options);
  }

  putById(id, options = {}) {
    return this.makeRequest(`${this.host}/internal/label/settings/${id}`, {
      ...options,
       method: 'PUT',
    });
  }

}
